import { render, staticRenderFns } from "./ArticleView.vue?vue&type=template&id=43dfe180&scoped=true&"
import script from "./ArticleView.vue?vue&type=script&lang=js&"
export * from "./ArticleView.vue?vue&type=script&lang=js&"
import style0 from "./ArticleView.vue?vue&type=style&index=0&id=43dfe180&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dfe180",
  null
  
)

export default component.exports